module.exports = __webpack_public_path__ + "static/img/w_23.d6bbc7ed.png";